// src/api/config.js
export const API_BASE = '/api/v2/admin';
export const PAYMENT_TIERS_API = '/api/v2/payments/tiers.php';  // This path is correct

export const EMAIL_API = `${API_BASE}/email-api.php`;
export const AMBASSADOR_API = `${API_BASE}/ambassador-applications.php`;

// Helper function for API calls
export const fetchAPI = async (endpoint, options = {}) => {
  const token = localStorage.getItem('token');
  
  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
    },
    ...options,
  };

  try {
    console.log(`Fetching: ${endpoint}`);
    const response = await fetch(endpoint, defaultOptions);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      console.error("Non-JSON response:", text.substring(0, 200));
      throw new Error("Server returned non-JSON response");
    }
    
    return await response.json();
  } catch (error) {
    console.error(`API call failed to ${endpoint}:`, error);
    throw error;
  }
};

// Subscribe to notifications
export const subscribeToNotifications = async (email, type = 'course_notification', name = '', tier = 'plus') => {
  try {
    const response = await fetch(EMAIL_API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        action: 'subscribe',
        email,
        name,
        type,
        tier,
        source: window.location.pathname,
        meta: {
          timestamp: new Date().toISOString()
        }
      })
    });
    
    const data = await response.json();
    return { success: true, data };
    
  } catch (error) {
    console.error('Subscription error:', error);
    // Store locally as fallback
    const subs = JSON.parse(localStorage.getItem('pending_subscriptions') || '[]');
    subs.push({ email, type, name, tier, timestamp: new Date().toISOString() });
    localStorage.setItem('pending_subscriptions', JSON.stringify(subs));
    
    return { success: true, fallback: true };
  }
};

// Submit ambassador application
export const submitAmbassadorApplication = async (applicationData) => {
  try {
    const response = await fetch(AMBASSADOR_API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(applicationData)
    });
    
    return await response.json();
    
  } catch (error) {
    console.error('Ambassador application error:', error);
    
    // Store locally as fallback
    API_CONFIG.storeLocally('ambassador_applications', {
      ...applicationData,
      submitted_at: new Date().toISOString()
    });
    
    return { success: true, fallback: true };
  }
};

export const API_CONFIG = {
  endpoints: {
    emailAPI: EMAIL_API,
    ambassadorAPI: AMBASSADOR_API
  },
  storeLocally: (key, data) => {
    try {
      const existing = JSON.parse(localStorage.getItem(key) || '[]');
      existing.push({ ...data, id: Date.now(), timestamp: new Date().toISOString() });
      localStorage.setItem(key, JSON.stringify(existing));
      return true;
    } catch (e) {
      return false;
    }
  }
};